<div class="custom-mat-dialog-form">
  <div>
    <h3>{{ InfoTypeConf.label }}</h3>
  </div>

  <div>
    <div style="display:flex; align-items: baseline">
      <button mat-icon-button (click)="refreshInformation()" matTooltip="Refresh Deployment Information">
        <mat-icon style="color:white">refresh</mat-icon>
      </button>
      Refresh
    </div>
    <!-- Deploy block -->
    <div>
      @if (showTable && !isLoading) {
        <table mat-table
          [dataSource]="dataSource"
          multiTemplateDataRows
          class="mat-elevation-z8 mat-table-custom"
          style="margin-top:15px">
          <ng-container matColumnDef="environment">
            <th mat-header-cell *matHeaderCellDef> Environment </th>
            <td mat-cell *matCellDef="let element">
              <p [innerHTML]="element.Name.toUpperCase()"></p>
            </td>
          </ng-container>
          <ng-container matColumnDef="environmentdeploymentStatus">
            <th mat-header-cell *matHeaderCellDef> Release Status </th>
            <td mat-cell *matCellDef="let element" pEditableColumn>
              <p>{{ getStatusLabel(element.Status) }}</p>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let element; let i = dataIndex;columns: columnsToDisplay;" class="opmode-item"></tr>
        </table>
      }
      @if (showDeploySpinner) {
        <h4>
          <span>Deploy in progress...</span>
          @if (showDeploySpinner) {
            <mat-spinner class="emt-spinner" diameter="20"></mat-spinner>
          }
        </h4>
      }
      @if (showDeployDuration) {
        <h5>
          <span>Last deploy duration: {{ lastDeployDuration }}</span>
        </h5>
      }
    </div>
    <!-- Build block -->
    @if (!isLoading && !showTable) {
      <div style="text-align:center">
        @if (pipelineStatusMessage) {
          <div style="margin-top: 10px; text-align: center;">
            <h4>
              <span>{{ pipelineStatusMessage }}</span>
              @if (showBuildSpinner) {
                <mat-spinner class="emt-spinner" diameter="20"></mat-spinner>
              }
              <br>
                @if (extraStatusMessage) {
                  <span> For more information,
                    <a [href]="extraStatusMessage" target="_blank" rel="noopener noreferrer"> click here </a>
                    <br> Generate new deployment or press Refresh to load last successfull release
                    </span>
                  }
                </h4>
              </div>
            }
            @if (isReleaseExpired) {
              <div>
                <h4>No build was found</h4>
              </div>
            }
          </div>
        }
        @if (isLoading) {
          <div class="whitebg card__desc" style="width: 100%; margin-left: 0; padding-top:15px">
            @for (_ of [].constructor(8); track _) {
              <div class="card__desc-text"></div>
            }
          </div>
        }
        <div>
          <br />
          <h5>How to deploy latest changes?</h5>
          <!-- EMT instructions -->
          @if (InfoTypeConf.buildReleaseType === BuildReleaseType.TdcEmt) {
            <ul>
              <li>1 - Create a new deployment pressing "Generate new Deployment" button to generate a build. It could take some minutes until it finishes.</li>
              <li>2 - Status of the deployment should update automatically. Alternatively, you can use the "Refresh" button.</li>
              <li>3 - When the new build is done, please press "Deploy to Stable" button or if you want to deploy it to production, please press "Deploy to Production" button.</li>
              <li>4 - If you need a new deployment, please click "Generate new Deployment" button.</li>
            </ul>
          }
          <!-- GLOBAL instructions -->
          @if (InfoTypeConf.buildReleaseType === BuildReleaseType.GlobalTaskList) {
            <ul>
              <li>1 - Create a new deployment pressing "Generate new Deployment to Stable" button. It could take some minutes until it finishes.</li>
              <li>2 - Status of the deployment should update automatically. Alternatively, you can use the "Refresh" button.</li>
              <li>3 - Wait until "Deployment Status" field shows a Succeeded message on stable stage.</li>
              <li>4 - If you want to deploy it also on production, please press "Deploy to Production" button. If you need a new deployment, please click "Generate new Deployment to Stable" button.</li>
            </ul>
          }
          <br />
          @if (buildRelease) {
            <div>
              @if (isReleaseExpired) {
                <div>
                  <h4>Current Build Id: {{buildRelease.BuildId}} (EXPIRED DUE TO RETENTION POLICY)</h4>
                </div>
              }
              @if (!isReleaseExpired) {
                <div>
                  <h4>Current Build Id: {{buildRelease.BuildId}}</h4>
                </div>
              }
              <h4>Creation Date UTC: {{buildRelease.CreatedDateUtc | date:'yyyy-MM-dd HH:mm'}}</h4>
            </div>
          }
        </div>
        <div class="mt-2 right">
          <button type="button"
            class="btn btn-primary"
            (click)="onClickDeploy()"
            [disabled]="!isLoading && !showTable && buildExists">
            {{ InfoTypeConf.buildReleaseType === BuildReleaseType.GlobalTaskList ? 'Generate new Deployment to Stable' : 'Generate new Deployment' }}
          </button>
          <!-- Deploy to Dev: visible in Dev (stage=2) and Stable (stage=0) -->
          @if (buildRelease?.ReleaseId !== -1 && currentStage !== 1) {
            <button type="button"
              class="btn btn-primary"
              (click)="releaseEnvironment(devEnvironment?.Id!)"
              [disabled]="devEnvironment?.Status !== 'NotStarted'">
              Deploy to Dev
            </button>
          }
          <!-- Deploy to Stable: visible only in Stable (stage=0) -->
          @if (buildRelease?.ReleaseId !== -1 && currentStage === 0) {
            <button type="button"
              class="btn btn-primary"
              (click)="releaseEnvironment(stableEnvironment?.Id!)"
              [disabled]="stableEnvironment?.Status !== 'NotStarted'">
              Deploy to Stable
            </button>
          }
          <!-- Deploy to Production: visible only in Production (stage=1) -->
          @if (buildRelease?.ReleaseId !== -1 && currentStage === 1) {
            <button type="button"
              class="btn btn-primary"
              (click)="releaseEnvironment(prodEnvironment?.Id!)"
              [disabled]="prodEnvironment?.Status !== 'NotStarted'">
              Deploy to Production
            </button>
          }
          <button type="button"
            class="btn btn-danger"
            (click)="backClick()">
            Back
          </button>
        </div>
      </div>
    </div>